"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.ehdIsEnabledAndNotExcludedFromNavigation = exports.getCurrentAnswerByQuestionId = exports.getCurrentAnswer = exports.setBlockedViewConfirmed = exports.setShowConfirm = exports.setBlockedQuestions = exports.resetState = exports.setSending = exports.setErrorText = exports.setBlockingText = exports.setDone = exports.setCurrentQuestionIndex = exports.setAnswers = exports.setQuestionData = exports.ehdSlice = void 0;
const toolkit_1 = require("@reduxjs/toolkit");
const lodash_1 = require("lodash");
const ehd_1 = require("../../helpers/ehd");
exports.ehdSlice = (0, toolkit_1.createSlice)({
    name: 'ehd',
    initialState: ehd_1.initialState,
    reducers: {
        setQuestionData: (state, action) => {
            state.questionData = action.payload;
        },
        setAnswers: (state, action) => {
            state.answers = action.payload;
        },
        setCurrentQuestionIndex: (state, action) => {
            state.currentQuestionIndex = action.payload;
        },
        setDone: (state, action) => {
            state.done = action.payload;
        },
        setBlockingText: (state, action) => {
            state.blockingText = action.payload;
        },
        setErrorText: (state, action) => {
            state.errorText = action.payload;
        },
        setShowConfirm: (state, action) => {
            state.showConfirm = action.payload;
        },
        setSending: (state, action) => {
            state.sending = action.payload;
        },
        setBlockedQuestions: (state, action) => {
            state.blockedQuestions = action.payload;
        },
        setBlockedViewConfirmed: (state, action) => {
            state.blockedViewConfirmed = action.payload;
        },
        resetState: (state) => {
            state.answers = ehd_1.initialState.answers;
            state.currentQuestionIndex = ehd_1.initialState.currentQuestionIndex;
            state.done = ehd_1.initialState.done;
            state.blockingText = ehd_1.initialState.blockingText;
            state.errorText = ehd_1.initialState.errorText;
            state.sending = ehd_1.initialState.sending;
            state.blockedQuestions = ehd_1.initialState.blockedQuestions;
            state.showConfirm = ehd_1.initialState.showConfirm;
            state.blockedViewConfirmed = ehd_1.initialState.blockedViewConfirmed;
        },
    },
});
_a = exports.ehdSlice.actions
// Selectors
, exports.setQuestionData = _a.setQuestionData, exports.setAnswers = _a.setAnswers, exports.setCurrentQuestionIndex = _a.setCurrentQuestionIndex, exports.setDone = _a.setDone, exports.setBlockingText = _a.setBlockingText, exports.setErrorText = _a.setErrorText, exports.setSending = _a.setSending, exports.resetState = _a.resetState, exports.setBlockedQuestions = _a.setBlockedQuestions, exports.setShowConfirm = _a.setShowConfirm, exports.setBlockedViewConfirmed = _a.setBlockedViewConfirmed;
// Selectors
exports.getCurrentAnswer = (0, toolkit_1.createSelector)([(state) => state.ehd.answers, (state) => state.ehd.currentQuestionIndex], (answers, index) => (Object.assign(Object.assign({}, answers[index]), { index })));
exports.getCurrentAnswerByQuestionId = (0, toolkit_1.createSelector)((state) => state.ehd.answers, (answers) => (0, lodash_1.memoize)((id) => {
    const answer = (0, lodash_1.find)(answers, { id });
    return answer
        ? Object.assign(Object.assign({}, (0, lodash_1.find)(answers, { id })), { index: (0, lodash_1.findIndex)(answers, { id }) }) : undefined;
}));
exports.ehdIsEnabledAndNotExcludedFromNavigation = (0, toolkit_1.createSelector)((state) => state.app.pages, (pages) => !!(pages === null || pages === void 0 ? void 0 : pages.ehd) && !pages.ehd.excludedFromNavigation);
exports.default = exports.ehdSlice.reducer;
